export default "__VITE_ASSET__DbByo1D5__"